// extracted by mini-css-extract-plugin
var _1 = "former-company-id__FVkat";
var _2 = "highlight__XfESl";
var _3 = "highlight-date__rGckc";
var _4 = "type-accident__fPVlA";
var _5 = "type-dueSoon__GCfeQ";
var _6 = "type-dueUrgent__GGmsJ";
export { _1 as "former-company-id", _2 as "highlight", _3 as "highlight-date", _4 as "type-accident", _5 as "type-dueSoon", _6 as "type-dueUrgent" }
